import { ContratoResumido } from "../../contratos/contrato-resumido";

export class RetornoImportarContratos {
  mensagem: string;
  contratosNaoImportados: ContratoResumido[];
  contratosImportados: ContratoResumido[];
  erros: string[];
  tipoErro: number;
  nomeArquivo: string;

  constructor(obj?: any) {
    if (obj) {
      this.mensagem = obj.mensagem;
      this.erros = obj.erros;
      this.tipoErro = obj.tipoErro;
      this.contratosNaoImportados = obj.contratosNaoImportados?.map(
        (cni) => new ContratoResumido(cni)
      );
      this.contratosImportados = obj.contratosImportados?.map(
        (ci) => new ContratoResumido(ci)
      );
    }
  }

  corSituacao(): string {
    return this.contratosNaoImportados?.length > 0 ||
      !this.contratosImportados
      ? "danger"
      : "success";
  }
  houveImportacao(): boolean {
    return this.contratosImportados?.length > 0;
  }
  houveNaoImportacao(): boolean {
    return this.contratosNaoImportados?.length > 0;
  }
}
